export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8475.7f6edf43.jpg";